"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListenerCollection = void 0;
const core_types_1 = require("@dqm/core-types");
class ListenerCollection {
    constructor(items = []) {
        this.items = items;
    }
    add(item) {
        this.items.push(item);
        let removed = false;
        return () => {
            if (removed) {
                throw new core_types_1.InvalidOperationError("already removed");
            }
            this.remove(item);
            removed = true;
        };
    }
    remove(item) {
        const index = this.items.indexOf(item);
        if (index < 0) {
            throw new core_types_1.InvalidOperationError("value not found");
        }
        this.items.splice(index, 1);
    }
    get() {
        return this.items;
    }
    invoke(...args) {
        for (const listener of this.get()) {
            listener(...args);
        }
    }
}
exports.ListenerCollection = ListenerCollection;
//# sourceMappingURL=ListenerCollection.js.map